import Icon from '@atoms/Icon/Icon';
import clsx from 'clsx';
import { useRef, useState } from 'react';
import { useEffect } from 'react';
import ReactPlayer from 'react-player/youtube';

import styles from './Video.module.scss';

interface Props {
  youtubeId: string;
  className?: string | false;
  autoplay?: boolean;
  loop?: boolean;
  showCustomControls?: boolean;
}

export default function YoutubeVideo({
  youtubeId,
  className,
  autoplay,
  loop,
  showCustomControls = false,
}: Props) {
  const isMounted = useRef(false);
  const [isPlaying, setIsPlaying] = useState(false);
  const playerRef = useRef<ReactPlayer>(null);
  const [isMuted, setIsMuted] = useState(true);

  const handleClick = () => {
    setIsPlaying(state => !state);
  };

  const handleToggleMute = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    setIsMuted(state => !state);
  };

  const replayVideo = () => {
    playerRef.current?.seekTo(0);
  };

  useEffect(() => {
    if (isMounted.current) return;
    isMounted.current = true;
  }, []);

  return (
    <div
      className={clsx(
        styles.mediaContainer,
        styles.youtubeContainer,
        isPlaying && styles.isPlaying,
        className,
      )}
      onClick={handleClick}
    >
      {isMounted.current && (
        <ReactPlayer
          ref={playerRef}
          className={styles.media}
          url={`https://www.youtube-nocookie.com/watch?v=${youtubeId}`}
          controls={false}
          muted={isMuted}
          playing={autoplay || isPlaying}
          loop={loop}
          width="100%"
          height="100%"
        />
      )}

      <div className={styles.pause}>
        <Icon icon="PAUSE_SOLID" className={styles.pauseIcon} strokeWidth={1} />
      </div>

      {showCustomControls && (
        <>
          <button
            onClick={handleToggleMute}
            className={clsx(styles.controls, styles.muteButton)}
          >
            <Icon
              icon={isMuted ? 'SOUND_OFF' : 'SOUND_HIGH'}
              className={styles.controlsIcon}
              strokeWidth={2}
            />
          </button>

          <button
            onClick={replayVideo}
            className={clsx(styles.controls, styles.restartButton)}
          >
            <Icon
              icon="RESTART"
              className={styles.controlsIcon}
              strokeWidth={2}
            />
          </button>
        </>
      )}
    </div>
  );
}
